import { BasicButton } from "./BasicButton";

export class ContinueButton extends BasicButton {
  private onContinueCallback?: () => void;

  constructor(scene: Phaser.Scene, onContinueCallback?: () => void) {
    super(
      scene,
      "Continue",
      {
        textureKey: "Button1",
      },
      {
        textureKey: "Button2",
      },
      undefined,
      undefined,
    );
    this.background.setTint(0xac4c3f);
    this.onContinueCallback = onContinueCallback;
  }

  handlePointerDown(): void {
    // Visual feedback handled by parent class
  }

  handlePointerUp(): void {
    if (this.onContinueCallback) {
      this.onContinueCallback();
    }
  }

  handlePointerOver(): void {
    // Visual feedback handled by parent class
  }

  handlePointerOut(): void {
    // Visual feedback handled by parent class
  }
}
